import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ngx-patientportalfooter',
  templateUrl: './patientportalfooter.component.html',
  styleUrls: ['./patientportalfooter.component.scss']
})
export class PatientportalfooterComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
